module.exports = __webpack_public_path__ + "img/SES_69003360.a9ddbac5.jpg";